import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { usePermissions } from '../../models/user/permissions';

import { Dropdown, Icon, Card, Button, ButtonDropdown, StopPropagation } from '@weezevent/nacre';
import { BoItems } from 'components';

import css from './list.module.css';

const OrganizationCard = React.memo(({ organization }) => {
    const history = useHistory();
    const { t } = useTranslation();
    const user = usePermissions();
    const canSeeUsers = user.canSeeFeatures(organization.id);
    const canManageWebhooks = user.canManageWebhooks();
    const { name, id } = organization;

    const organizationName = React.useMemo(() => {
        if (!name) {
            return t('sauron.organizations.organization_without_name');
        }
        return name;
    }, [name]);

    return (
        <Card key={id} className={css['organization-card']} onClick={() => history.push(`organizations/O${id}/events`)}>
            <div className={css['organization-header']}>
                <div>
                    <div className={css['organization-id-container']}>
                        <Icon name="institution" />
                        <div className={css['organization-id']}>O {id}</div>
                    </div>
                    <div className={css['organization-name']}>{organizationName}</div>
                </div>
                <StopPropagation>
                    <ButtonDropdown
                        className={css['organization-actions']}
                        renderWhenClosed
                        trigger={<Button inverted primary icon={<Icon name="chevron-bottom" />} label={t('common.actions')} />}
                        items={[
                            <Dropdown.Item
                                key={'users'}
                                item={t('sauron.organizations.see-users')}
                                onClick={() => history.push(`organizations/O${id}/users`)}
                                disabled={!canSeeUsers}
                            />,
                            canManageWebhooks && (
                                <Dropdown.Item key={'webhooks'} item={t('sauron.organizations.see-webhooks')} onClick={() => history.push(`organizations/O${id}/tools/webhooks`)} />
                            )
                        ]}
                    />
                </StopPropagation>
            </div>
            <BoItems organizationId={id} eventId={null} />
        </Card>
    );
});

export default OrganizationCard;
